import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import AnchorLink from "../components/AnchorLinkComponent";


class FullListOfIndustries extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Full List of Industries in which I have Experience.</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>These are some of the Industries that I have contracted in:</p>
                        <ul >
                            <li><AnchorLink value="Consumer" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/industries/consumer'/></li>
                            <li><AnchorLink value="Aviation / Aerospace / Marine" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/industries/aerospace_marine'/></li>
                            <li><AnchorLink value="Homeland Security / Defense" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/industries/defense_homeland_security'/></li>
                            <li><AnchorLink value="Medical and Medical Devices" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/industries/medical'/></li>
                            <li><AnchorLink value="Financial and Insurance" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/industries/finance_insur'/></li>
                            <li><AnchorLink value="Navigation, Mapping and GPS" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/industries/nav_map_gps'/></li>
                            <li><AnchorLink value="Embedded and 'Internet of Things' (IoT)" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/industries/iot'/></li>
                        </ul>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                </div>
            </div>
        );
    }
}

export default FullListOfIndustries



// WEBPACK FOOTER //
// src/Industries/FullListOfIndustries.js